<template>
  <el-card shadow="hover" :class="{ is_top: value.is_top, is_deleted: value.is_deleted, admin_read: value.admin_read }">
    <div slot="header" class="clearfix">
      <div class="box-tags">
        <el-tag v-if="!value.admin_read" type="warning" size="mini">未读</el-tag>
        <el-tag v-if="value.is_top" type="danger" size="mini">已置顶</el-tag>
        <el-tag v-if="value.is_deleted" type="danger" size="mini">已隐藏</el-tag>
      </div>

      <div class="box-header">
        <div class="header-content">
          <CommentCard :value="value" />
        </div>
        <div class="header-action">
          <bean-ability can="normal_comments.update">
            <el-button v-if="!value.parent_id"  type="text" @click="handleToggleTop">{{ value.is_top ? '取消置顶' : '置顶' }}</el-button>
          </bean-ability>
          <bean-ability can="normal_comments.update">
            <el-button type="text" @click="handleToggleHidden">{{ value.is_deleted ? '取消隐藏' : '隐藏' }}</el-button>
          </bean-ability>
          <el-button type="text" @click="handleSetReaded" v-if="!value.admin_read">设为已读</el-button>
        </div>
      </div>
    </div>
    <div class="card-content">
      <CommentCard v-if="value.parent" :value="value.parent" />
      <div v-if="value.commentable" class="article-card-container" :class="{ 'border-top': !!value.parent }">
       <ArticleCard :value="value.commentable" />
      </div>
    </div>
  </el-card>
</template>

<script>
import { Vue, Component, Model, Emit } from 'vue-property-decorator';
import moment from 'moment';
import ArticleCard from './card-article.vue';
import CommentCard from './card-comment.vue';

@Component({
  components: {
    ArticleCard,
    CommentCard
  }
})
export default class TableItem extends Vue {
  @Model('change', { type: Object, default: () => ({}) }) value;

  get createTime() {
    return moment(this.value.created_at).format('YYYY-MM-DD HH:mm:ss');
  }

  @Emit('change')
  async handleToggleTop() {
    const { id, is_top } = this.value;
    await this.$autoLoading(
      this.$request.put(`/comments/${id}/${is_top ? 'position_to_nil' : 'position_to_minimum'}`)
    );
    this.$message.success(this.$t('operateSuccess'));
    return {
      ...this.value,
      is_top: !is_top
    }
  }

  @Emit('change')
  async handleToggleHidden() {
    const { id, is_deleted } = this.value;
    await this.$autoLoading(
      this.$request.put(`/comments/${id}/${is_deleted ? 'show' : 'hide'}`)
    );
    this.$message.success(this.$t('operateSuccess'));
    return {
      ...this.value,
      is_deleted: !is_deleted
    }
  }

  @Emit('change')
  async handleSetReaded() {
    await this.$autoLoading(
      this.$request.post('/normal_comments/batch_read', { id_in: [this.value.id] })
    );
   this.$message.success(this.$t('operateSuccess'));
   return {
      ...this.value,
      admin_read: true
    }
  }
}
</script>

<style lang="scss" scoped>
  .el-card {
    &.is_top {
      border-color: $danger;
    }

    &.is_deleted {
      opacity: .6;
    }
  }

  .box-tags {
    .el-tag {
      margin-right: 10px;
      margin-bottom: 15px;
    }
  }

  .box-header {
    display: flex;

    .header-content {
      flex: 1;
      font-size: 14px;

      /deep/ .comment-content {
        font-size: 16px;
        font-weight: bold;
      }
    }

    .header-action {
      margin-left: 30px;
      flex-shrink: 0;
    }
  }

  /deep/ .el-card__header,  /deep/ .el-card__body {
    padding-top: 10px;
    padding-bottom: 10px;
  }

  /deep/ .el-card__body {
    background-color: #f5f5f5;
  }

  .article-card-container {
    &.border-top {
      border-top: 1px solid $border-light;
    }
  }
</style>
